import { KrCard } from '@/common/card/KrCard';
import { useFieldDefs } from '@/common/entityFramework/entityForm/FieldDefsContext';
import { useMemo } from 'react';
import { FormFields } from '../rendering/FormFields';

export const EntitySectionCard = ({ title }) => {
  const { fieldDefs } = useFieldDefs();
  const sectionFieldDefs = useMemo(() => fieldDefs?.filter((fd) => fd.section === title), [fieldDefs, title]);

  return (
    <KrCard minHeight={0} title={title}>
      <FormFields fieldDefs={sectionFieldDefs} />
    </KrCard>
  );
};
